var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="register_empty"> <div class="container-scroller"> <div class="container-fluid page-body-wrapper full-page-wrapper"> <div class="content-wrapper d-flex align-items-center auth px-0"> <div class="row w-100 mx-0"> <div class="col-lg-4 mx-auto"> <div class="auth-form-light text-left py-5 px-4 px-sm-5">  <h6 class="font-weight-light">'+
((__t=( resources['X200020'] ))==null?'':__t)+
'</h6> <form class="pt-3"> <div class="form-group"> <label for="exampleInputEmail">'+
((__t=( resources['X200021'] ))==null?'':__t)+
'</label> <div class="input-group"> <div class="input-group-prepend bg-transparent"> <span class="input-group-text bg-transparent border-right-0"> <i class="mdi mdi-account-outline text-primary"></i> </span> </div> <input class="form-control form-control-lg border-left-0" id="forgotPassword_inputEmail" placeholder="'+
((__t=( resources['X200021'] ))==null?'':__t)+
'"> </div> </div> <div class="mt-3"> <a id="forgotPassword_btnSubmit" class="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn">'+
((__t=( resources['X200020'] ))==null?'':__t)+
'</a> </div> <p id="forgotPassword_p_verifyOK" style="display:none">'+
((__t=( resources['X200022'] ))==null?'':__t)+
'</p> <div id="recaptcha_container"></div> <div style="height:10px"></div> </form> </div> </div> </div> </div> </div> </div> </div>';
}
return __p;
};
